/**
 * fetchCache — TTL-based localStorage cache for JSON API responses.
 *
 * cachedFetchJSON(url, ttlMs?) — fetches JSON from url, caching the result
 * in localStorage. Returns cached data if fresh; re-fetches if stale or missing.
 * Silently skips writing to cache if localStorage quota is exceeded.
 * Throws on HTTP errors (same contract as fetch + res.json()).
 *
 * Recommended TTLs:
 *   DATA_TTL — 24 hours — Census / CDC data (updates annually)
 *   GEO_TTL  — 7 days  — TIGER GeoJSON, county lists (essentially static)
 */

export const DATA_TTL = 24 * 60 * 60 * 1000;
export const GEO_TTL  = 7 * 24 * 60 * 60 * 1000;

const CACHE_PREFIX = 'fcp_v1_';

export async function cachedFetchJSON(url, ttlMs = DATA_TTL) {
  const key = CACHE_PREFIX + url;

  try {
    const raw = localStorage.getItem(key);
    if (raw) {
      const { d, t } = JSON.parse(raw);
      if (Date.now() - t < ttlMs) return d;
      localStorage.removeItem(key);
    }
  } catch (_) {}

  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${url}`);
  const data = await res.json();

  try {
    localStorage.setItem(key, JSON.stringify({ d: data, t: Date.now() }));
  } catch (_) {}

  return data;
}
